import { HttpClient, HttpHeaders } from '@angular/common/http';
import { inject, Service } from '@angular/core';
import {Observable} from 'rxjs';
import {environment} from '../../environments/environment';
import {OrgUnitHeader} from '../organization/org-unit-header';
import {Organization} from '../organization/organization';
import {GoogleService} from './google-service';
import {StringUtils} from "../utils/string-utils";

@Service()
export class OrganizationService {
  private readonly http = inject(HttpClient);
  private readonly googleService = inject(GoogleService);


  private urlBase = environment.serviceUrl;

  public search(term: string): Observable<OrgUnitHeader[]> {
    let url = this.urlBase + 'organizations/search/' + term;
    return this.http.get<OrgUnitHeader[]>(url, {headers: this.getRequestHeaders()});
  }

  private getRequestHeaders(): HttpHeaders {
    return new HttpHeaders().set(GoogleService.TokenHeader, this.googleService.getAccessToken());
  }

  private getPostHeaders(): HttpHeaders {
    return this.getRequestHeaders().set("Content-Type", "application/json");
  }

  public getOrganization(id: string): Observable<Organization> {
    let url = this.urlBase + 'organizations/' + id;
    return this.http.get<Organization>(url, {headers: this.getRequestHeaders()});
  }

  public save(organization: Organization): Observable<Organization> {
    let url = this.urlBase + 'organizations/save';
    let body = JSON.stringify(organization);
    return this.http.post<Organization>(url, body, {headers: this.getPostHeaders()});
  }

  isSiblingOrg(organization: Organization): boolean {
    const orgUnitId: string = organization?.orgUnitId || '';
    const parentId: string = organization?.parentOrg || '';
    return StringUtils.isNotBlank(orgUnitId) && StringUtils.isNotBlank(parentId) && !StringUtils.equalsIgnoreCase(orgUnitId, parentId);
  }

  deactivate(organization: Organization): Observable<string> {
    const url = this.urlBase + 'organizations/deactivate';
    const body = JSON.stringify(organization);
    return this.http.post(url, body, {headers: this.getPostHeaders(), responseType: 'text'});
  }

}
